// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".meta-number[data-v-51854c9e]{display:flex;flex-direction:column;gap:8px}.meta-number__value[data-v-51854c9e]{color:#000;font-size:40px;line-height:100%}.meta-number__label[data-v-51854c9e]{color:#666e75;font-size:16px;line-height:150%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
